(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_inquiry-calculator"] && !Shopify.designMode) return;
  try {
    (function() {
    const blockEl = document.querySelector('[data-block-id="{{ block.id }}"]');
    if (!blockEl) return;

    // ---- Area Calculator ----
    const lenInput   = document.getElementById('calc-length-{{ block.id }}');
    const widInput   = document.getElementById('calc-width-{{ block.id }}');
    const resultEl   = document.getElementById('calc-result-value-{{ block.id }}');

    function calcArea() {
      const l = parseFloat(lenInput ? lenInput.value : 0);
      const w = parseFloat(widInput ? widInput.value : 0);
      if (!isNaN(l) && !isNaN(w) && l > 0 && w > 0) {
        resultEl.textContent = (l * w).toFixed(2) + ' m²';
        resultEl.classList.add('inquiry-calculator__result-value--filled');
      } else {
        resultEl.textContent = '—';
        resultEl.classList.remove('inquiry-calculator__result-value--filled');
      }
    }

    if (lenInput) lenInput.addEventListener('input', calcArea);
    if (widInput) widInput.addEventListener('input', calcArea);

    // ---- Popup Trigger ----
    const inquiryBtn = blockEl.querySelector('[data-open-inquiry]');
    if (inquiryBtn) {
      inquiryBtn.addEventListener('click', function() {
        const popupId = this.getAttribute('data-open-inquiry');
        const popup   = document.getElementById(popupId);
        if (popup) {
          popup.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
          // Pre-fill area if calculated
          const areaInput = popup.querySelector('[name="contact[area]"]');
          if (areaInput && resultEl && resultEl.textContent !== '—') {
            areaInput.value = resultEl.textContent;
          }
          const firstInput = popup.querySelector('input:not([type=hidden]), textarea');
          if (firstInput) setTimeout(() => firstInput.focus(), 80);
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
